"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const TopicPilotLanguageMap_1 = require("../constants/TopicPilotLanguageMap");
const Route_1 = __importDefault(require("../stores/Route"));
const useTopicPilotQueryString = () => {
    return (0, react_1.useMemo)(() => {
        const language = !!Route_1.default.localeOfUrl ? (TopicPilotLanguageMap_1.TopicPilotLanguageMap[Route_1.default.localeOfUrl] ?? '') : '';
        const params = new URLSearchParams();
        if (!!language) {
            params.set('lang', language);
        }
        if (params.size > 0) {
            return `?${params.toString()}`;
        }
        return '';
    }, []);
};
exports.default = useTopicPilotQueryString;
